var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AppLayout',{attrs:{"fluid":""}},[_c('VContainer',{attrs:{"id":"terms-page"}},[_c('VRow',{attrs:{"row":"","justify-center":""}},[_c('VCol',{attrs:{"md":"10","lg":"8","cols":"12","align-self-center":""}},[_c('Privacy')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }